import { render, staticRenderFns } from "./ProjectAppointOrgan.vue?vue&type=template&id=6ea741eb&scoped=true&"
import script from "./ProjectAppointOrgan.vue?vue&type=script&lang=js&"
export * from "./ProjectAppointOrgan.vue?vue&type=script&lang=js&"
import style0 from "./ProjectAppointOrgan.vue?vue&type=style&index=0&id=6ea741eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea741eb",
  null
  
)

export default component.exports